module.exports = __webpack_public_path__ + "img/success.af2f6f7d.jpg";